import React, { Component, Suspense } from 'react'
import {connect} from "react-redux";
import {createStructuredSelector} from "reselect"
import {
	_handleGeocoderViewportChange,
	onCloseStartScreen,
	_handleSelectLocationFromGeocoder,
	onMapClick,
	onMapHover,
	_onViewportChange,
	_toggleSatelliteLayer,
	handleMouseUpOnMap,
	handleMapFirstLoaded,
	handleMapTransitionEnd,
	handleMapTransitionStart,
	handleTransitionInterrupt,
	handlePopupClose,
	pullReduxStateFromURLIfAny,
	saveMapRefToRedux,
	_updateMapStyleOnVisibilityChange,
	_handleSceneChange,
	selectCommunityAndFetchItsGeoIdLookupData,
} from "./Redux/Actions/mapActions";
import {updateFieldFilterBounds} from "./Redux/Actions/cartoACSDataActions";
import {
	currentSceneIndexSelector,
	viewportSelector,
	settingsSelector,
	visibleLayersSelector,
	storyMapModeSelector,
	presenterModeActiveSelector,
	showStartScreenSelector,
	selectedRegionInfoSelector,
	activeMapboxFiltersSelector,
	clickedLayersInfoSelector,
	rawStorymapSelector,
	mapStyleSelector,
	
	showSatelliteLayerSelector,
	_mapRefSelector, initialLoadOfMapHasCompletedSelector, selectedUSStatesToFilterWithinSelector,
} from "./Redux/selectors";

import ReactMapGL, {NavigationControl, FullscreenControl} from 'react-map-gl'
import 'd3-transition'
import ArrowKeysReact from 'arrow-keys-react'
import config from './content/config'
import SlideNavigationControls from "./UIComponents/LeftPanelDashboard/SlideNavigationControls";

import Tooltip from './UIComponents/Tooltip'

const NavBar = React.lazy(() => import('./UIComponents/NavBar'))
const StoryMapControls = React.lazy(() => import('./UIComponents/StoryMapControls'))
const Geocoder = React.lazy(() => import('react-map-gl-geocoder'))

const fullscreenControlStyle = {
	position: 'absolute',
	bottom: 40,
	right: 0,
	padding: '10px',
};
const navStyle = {
	position: 'absolute',
	bottom: 76,
	right: 0,
	padding: '10px'
};


class TheEntireMapApp extends Component {
	constructor(props) {
		super(props);
		ArrowKeysReact.config({
			left: () => {
				const {currentSceneIndex} = this.props
				this.props._handleSceneChange(currentSceneIndex - 1)
			},
			right: () => {
				const {currentSceneIndex} = this.props
				this.props._handleSceneChange(currentSceneIndex + 1)
			},
		});

		props.pullReduxStateFromURLIfAny()

		this.geocoderContainerRef = React.createRef();
	}


	// MAP STYLING

	// INTERACTIVITY
	
	handleViewportChange = viewport => this.props._onViewportChange(viewport)

	render() {
		//console.log('MAP re-render')
		const { rawStorymap, mapStyle } = this.props
		if (rawStorymap === null || mapStyle === null) {
			return null
		}

		const { viewport, settings, currentSceneIndex, storyMapMode, presenterModeActive, showStartScreen, selectedRegionInfo, activeMapboxFilters, clickedLayersInfo } = this.props

		const hideNavBar = presenterModeActive //&& currentSceneIndex !== 0

		return ( // Tap Index means after the div is "focused" (ie clicked) you can use the arrow keys to navigate the scenes.
			<div className="the-entire-map-app" {...ArrowKeysReact.events} tabIndex="1">
				<Suspense fallback={<div/>}>
					<div className="cori-made-by">
						<a href="https://ruralinnovation.us" target="_blank" rel="noopener noreferrer">© Center on Rural Innovation</a>
					</div>
					
					<NavBar
						showStartScreen={showStartScreen}
						hideNavBar={hideNavBar}
						currentSceneIndex={currentSceneIndex}
						geocoderContainerRef={this.geocoderContainerRef}
					/>
					<Geocoder
						containerRef={this.geocoderContainerRef}
						mapRef={this.props._mapRef}
						onViewportChange={this.props._handleGeocoderViewportChange}
						onResult={this.props._handleSelectLocationFromGeocoder}
						mapboxApiAccessToken={config.MAPBOX_TOKEN}
						position="top-right"
						countries={'US'}
						clearAndBlurOnEsc={true}
						clearOnBlur={true}
						placeholder="Investigate another location (town, county, etc.)"
					/>
				</Suspense>
				
				<div style={{display: 'flex'}}>
					<Suspense fallback={<div/>}>
						<StoryMapControls
							storyMapMode={storyMapMode}
							clickedLayersInfo={clickedLayersInfo}
							updateFieldFilterBounds={this.props.updateFieldFilterBounds}
							activeMapboxFilters={activeMapboxFilters}
							onToggleSatelliteLayer={this.props._toggleSatelliteLayer}
							checkSatelliteLayer={this.props.showSatelliteLayer}
							{...selectedRegionInfo}
						/>
					</Suspense>
					<Tooltip />
					<div onMouseLeave={() => this.props.onMapHover({features: null, point: [null, null]})}>
						<ReactMapGL
							ref={this.props._mapRef}
							{...settings}
							{...viewport}
							mapStyle={mapStyle}
							onViewportChange={this.handleViewportChange}
							onClick={this.props.onMapClick}
							onHover={this.props.onMapHover}
							onMouseUp={this.props.handleMouseUpOnMap} // ie after a button click or click-and-drag-to-pan
							onTransitionStart={this.props.handleMapTransitionStart}
							onTransitionEnd={this.props.handleMapTransitionEnd}
							onTransitionInterrupt={this.props.handleTransitionInterrupt}
							onLoad={this.props.handleMapFirstLoaded}
							mapboxApiAccessToken={config.MAPBOX_TOKEN}
						>
							{!showStartScreen && <div className="fullscreen" style={fullscreenControlStyle}>
								<FullscreenControl />
							</div>}
							{!showStartScreen && <div className="nav" style={navStyle}>
								<NavigationControl showCompass={false}/>
							</div>}
							<SlideNavigationControls />
						</ReactMapGL>
					</div>
				</div>

				
			</div>
		);
	}

}

// Redux

const mapStateToProps = createStructuredSelector({

	rawStorymap: rawStorymapSelector,
	mapStyle: mapStyleSelector,

	currentSceneIndex: currentSceneIndexSelector,
	viewport: viewportSelector,
	settings: settingsSelector,
	visibleLayers: visibleLayersSelector,
	storyMapMode: storyMapModeSelector,
	presenterModeActive: presenterModeActiveSelector,
	showStartScreen: showStartScreenSelector,
	initialLoadOfMapHasCompleted: initialLoadOfMapHasCompletedSelector,
	selectedRegionInfo: selectedRegionInfoSelector,
	selectedUSStatesToFilterWithin: selectedUSStatesToFilterWithinSelector,
	activeMapboxFilters: activeMapboxFiltersSelector,
	clickedLayersInfo: clickedLayersInfoSelector,
	
	showSatelliteLayer: showSatelliteLayerSelector,
	_mapRef: _mapRefSelector,
})

// Redux AND es6 shorthand formats for the Actions to inject into props with access to the dispatch function
const mapDispatchToProps = {
	pullReduxStateFromURLIfAny,
	handleMapFirstLoaded,
	saveMapRefToRedux,

	_onViewportChange,
	_handleGeocoderViewportChange,
	_updateMapStyleOnVisibilityChange,
	handleMapTransitionEnd,
	handleMapTransitionStart,
	handleTransitionInterrupt,

	onCloseStartScreen,

	_handleSelectLocationFromGeocoder,
	selectCommunityAndFetchItsGeoIdLookupData,
	_toggleSatelliteLayer,
	_handleSceneChange,

	onMapClick,
	onMapHover,
	handleMouseUpOnMap,
	handlePopupClose,


	// From ACS Data
	updateFieldFilterBounds,
}

export default connect(mapStateToProps, mapDispatchToProps)(TheEntireMapApp)
